import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  vehicleDetailTitle: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleDetailTitle),
  vehicleTypeLabel: () => i18n.t(i18nKeys.backgroundCheck__vehicleTypeLabel),
  required: () => i18n.t(i18nKeys.common__required),
  makeLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__makeLabel),
  modelLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__modelLabel),
  colorLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__colorLabel),
  insuranceCertificationLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__insuranceCertificationLabel),
  continue: () => i18n.t(i18nKeys.common__continue),
  colors: {
    silver: () => i18n.t(i18nKeys.common__color__silver),
    white: () => i18n.t(i18nKeys.common__color__white),
    black: () => i18n.t(i18nKeys.common__color__black),
    blue: () => i18n.t(i18nKeys.common__color__blue),
    gray: () => i18n.t(i18nKeys.common__color__gray),
    red: () => i18n.t(i18nKeys.common__color__red),
    green: () => i18n.t(i18nKeys.common__color__green),
    brown: () => i18n.t(i18nKeys.common__color__brown),
    gold: () => i18n.t(i18nKeys.common__color__gold),
    tan: () => i18n.t(i18nKeys.common__color__tan),
    orange: () => i18n.t(i18nKeys.common__color__orange),
    yellow: () => i18n.t(i18nKeys.common__color__yellow),
    purple: () => i18n.t(i18nKeys.common__color__purple),
  },
}
